import AgentPersonal from "./content/agent-personal.jsx";
import AgentsDocuments from "./content/agents-documents.jsx";
import AgentClothes from "./content/agent-clothes.jsx";
import AgentPhones from "./content/agent-phones.jsx";
import ConductHistory from "./content/conduct-history.jsx";
import AgentsPrivateWeapons from "./content/agents-private-weapons.jsx";
import AgentsDayOff from "./content/agents-day-off.jsx";
import AgentDependents from "./content/agent-dependents.jsx";
import AgentSkillRestriction from "./content/agent-skill-restriction.jsx";
import PrintSection from "../../../../../components/print-options-modal/print-section.jsx";
import AgentTrainings from "./content/agent-trainings.jsx";

function hasContent(data) {
    if (data === null || data === undefined) return false;
    if (Array.isArray(data)) return data.some(hasContent);
    if (typeof data === "object") return Object.values(data).some(hasContent);

    return String(data).trim() !== "";
}

function ValidationHelper({ data, children }) {
    const hasData = hasContent(data);
    if (!hasData) return null;

    return children;
}

export default function ReportContent({ data, visibleModules, printOptions }) {
    return (
        <div className="space-y-4">
            <AgentPersonal data={data} visible={printOptions?.address}/>

            <PrintSection visible={printOptions?.phones}>
                <ValidationHelper data={data?.devicesView}>
                    <AgentPhones data={data}/>
                </ValidationHelper>
            </PrintSection>

            { visibleModules?.documents && (
                <PrintSection visible={printOptions?.documents}>
                    <ValidationHelper data={data?.documents}>
                        <div className="gap-4!">
                            <AgentsDocuments data={data}/>
                        </div>
                    </ValidationHelper>
                </PrintSection>
            )}

            { visibleModules?.trainings && (
                <PrintSection visible={printOptions?.trainings}>
                    <ValidationHelper data={data?.trainings}>
                        <AgentTrainings data={data}/>
                    </ValidationHelper>
                </PrintSection>
            )}

            { visibleModules?.conductHistory && (
                <PrintSection visible={printOptions?.conductHistory}>
                    <ValidationHelper data={data?.conductHistory}>
                        <ConductHistory data={data}/>
                    </ValidationHelper>
                </PrintSection>
            )}

             {visibleModules?.privateWeapons && (
                <PrintSection visible={printOptions?.privateWeapons}>
                    <ValidationHelper data={data?.privateWeapons}>
                        <AgentsPrivateWeapons data={data}/>
                    </ValidationHelper>
                </PrintSection>
            )}

            { visibleModules?.dayOff && (
                <PrintSection visible={printOptions?.dayOff}>
                    <ValidationHelper data={data?.dayOff}>
                        <AgentsDayOff data={data}/>
                    </ValidationHelper>
                </PrintSection>
            )}

            { visibleModules?.clothes && (
                <PrintSection visible={printOptions?.clothes}>
                    <ValidationHelper data={data?.clothes}>
                        <AgentClothes data={data}/>
                    </ValidationHelper>
                </PrintSection>
            )}

            { visibleModules?.dependents && (
                <PrintSection visible={printOptions?.dependents}>
                    <ValidationHelper data={data?.dependents}>
                        <AgentDependents data={data}/>
                    </ValidationHelper>
                </PrintSection>
            )}

            { visibleModules?.skillsRestrictions && (
                <PrintSection visible={printOptions?.skillsRestrictions}>
                    <ValidationHelper data={data?.skillsRestriction}>
                        <AgentSkillRestriction data={data}/>
                    </ValidationHelper>
                </PrintSection>
            )}
        </div>
    )
}